import { RequestApi } from '_helpers';

const createUserWaiver = async (userData: FormData) => {
  const response = await RequestApi.post('/waiver/createUserWaiver', userData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
};

const waiverService = {
  createUserWaiver,
};

export default waiverService;
